export class Values extends Phaser.Group {
  constructor (game, memory, valuesHeight, valuesWidth) {
    super(game, null, 'values')

    this.memory = memory
    this.valuesHeight = valuesHeight
    this.valuesWidth = valuesWidth
    this.pointer = 0

    if (game.state.getCurrentState().levelIndex === 1) {
      valuesHeight = 1
    }

    for (let i = 0; i < valuesHeight; i++) {
      this.createObjectValues()
    }
  }

  createObjectValues () {
    const index = this.children.length
    const memory = this.memory.offset(index, 0)

    const objectValues = new ObjectValues(this.game, memory, this.valuesWidth, `values-${index}`)
    objectValues.y = TILE_HEIGHT * index

    this.add(objectValues)
  }

  next () {
    if (this.pointer === this.valuesHeight) {
      throw new Error('Too many objects!')
    }
    return this.getAt(this.pointer++)
  }
}

export class ObjectValues extends Phaser.Group {
  constructor (game, memory, valuesWidth, groupName) {
    super(game, null, groupName)

    this.memory = memory
    this.pointer = 0

    for (let i = 0; i < valuesWidth; i++) {
      this.createValue()
    }
  }

  createValue () {
    const index = this.children.length

    const memory = this.memory.cell(0, index)
    const label = new Phaser.BitmapText(this.game, index * TILE_WIDTH + 3, 4, 'monospace', toHex(memory.get()), 9)
    label.memory = memory
    this.add(label)

    memory.watch((value) => {
      const fadeOut = this.game.add.tween(label)
      fadeOut.to({alpha: 0}, 50, Phaser.Easing.Linear.None, false)
      fadeOut.onComplete.add(() => { label.text = toHex(value) })

      const fadeIn = this.game.add.tween(label)
      fadeIn.to({alpha: 1}, 50, Phaser.Easing.Linear.None, false)
      fadeOut.chain(fadeIn)

      fadeOut.start()
    })
  }

  next (tint = 0xffffff) {
    if (this.pointer === this.valuesWidth) {
      throw new Error(`Too many values for ${this.name}`)
    }
    const label = this.getAt(this.pointer++)
    label.tint = tint

    return label.memory
  }
}

function toHex (value) {
  return `${Math.floor(value / 16).toString(16).toUpperCase()}${(value % 16).toString(16).toUpperCase()}`
}
